






































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'
import AddressEdit from '@/components/administration/address/AddressEdit.vue'   

@Component({
  name: 'GestionPiscine' ,
  components:{AddressEdit} 
})
export default class GestionPiscine extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newPiscine = getDefaultAloPiscine()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }
  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private headers = [
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Active', value: 'psnEnable', width:90 },
    { text: 'Ville', value: 'address.libelle', width:110 },
    { text: 'Nom Piscine', value: 'libelle' },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get piscineList() {
    return this.$store.myGetters.piscineList
  }

  private get search(){
    return this.$store.myGetters.searchPiscine
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_PISCINE(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortPiscineDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_PISCINE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortPiscineBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_PISCINE_BY(value)
  }

    
  created() {
    this.loading = true
    this.$store.myActions.ADM_PISCINE_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyPiscine',params:{piscineId:item.id}})    
  }

  deletePiscine(piscine:AloPiscine) {
     if(piscine.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la piscine "${piscine.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_PISCINE_DELETE_REQUEST(piscine.id)
        } 
      })          
    } 
  }

  addPiscine(){
    this.showNew = true  
    this.newPiscine = getDefaultAloPiscine()
  }

  save(){
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.$store.myActions.ADM_PISCINE_SAVE_REQUEST(this.newPiscine).then((piscine)=>{
        this.showNew = false
        this.openDetail(piscine)
      })    
    }
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Piscines',
          disabled: true,  
          to: {name:'AdminPiscine'},        
          exact:true
        }
      ]      
  } 
 
}
